import { ChakraFlex, Text } from '@equip.health/ui';
import ProviderCard, { ConfirmationProvider } from './ProviderCard';
import AppointmentList, { ConfirmationAppointment } from './AppointmentList';
import { CONFIRMATION_STEP_TEST_ID, CONFIRMATION_SUBTITLE_TEXT } from '../constants';

export interface ConfirmationStepProps {
  appointments: ConfirmationAppointment[];
  patientTimezone?: string;
  provider: ConfirmationProvider;
}

const ConfirmationStep = ({
  appointments,
  patientTimezone,
  provider,
}: ConfirmationStepProps) => {
  return (
    <ChakraFlex
      data-testid={CONFIRMATION_STEP_TEST_ID}
      flexDirection="column"
      gap="24px"
      height="100%"
      overflowY="auto"
    >
      <ProviderCard provider={provider} />
      <ChakraFlex flexDirection="column" gap="12px">
        <Text variant="h5">Proposed Appointments</Text>
        <Text color="neutral.primary" variant="body">
          {CONFIRMATION_SUBTITLE_TEXT}
        </Text>
      </ChakraFlex>
      <AppointmentList
        appointments={appointments}
        patientTimezone={patientTimezone}
      />
    </ChakraFlex>
  );
};

export default ConfirmationStep;
